
import axios from 'axios';
import {
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESSPLAN,
  ASYNC_FETCH_FAILURE,
  SET_SELECTED_REMARK,
  SET_CONFIRM_PLANCHANGE,
  SET_ISREMARKS_LOAD,
  SET_ISREDIRECT_TO_HUB
} from '../constants';
import httpClient, { getHttpClientRequest, postHttpClientRequest, isUnAuth } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';

export const getRemarksSections = (postData, isEffectiveDate) => dispatch => {

  dispatch(asyncFetch());
  const onSuccess = response => {
    dispatch(asyncCallStatus(response.data));
  };
  const onError = error => {
    dispatch(asyncFetchFailed(error));
  };
  const callMS = (postData) => {
    var axConfig = {
      headers: { pageName: "remarks", subServiceName: "remarks" }
    };
   
    if (apiUrl().remarksSelectionUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(apiUrl().remarksSelectionUrl, axConfig);
    } else {
      return postHttpClientRequest(
        apiUrl().remarksSelectionUrl,
        postData,
        axConfig
      );
    }


  };
  callMS(postData)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
        onError(msResp);

      }
    })
    .catch(onError);
};


export const asyncFetch = urlParams => ({
  type: ASYNC_FETCH,
  urlParams
});
export const asyncCallStatus = msResp => ({
  type: ASYNC_FETCH_SUCCESSPLAN,
  msResp
});
export const asyncFetchFailed = err => ({
  type: ASYNC_FETCH_FAILURE,
  err
});
export const setSelectedRemarkValue = data => ({
  type: SET_SELECTED_REMARK,
  data
});
export const setConfirmPlanChange = data => ({
  type: SET_CONFIRM_PLANCHANGE,
  data
});

export const setRemarksLoad = data => ({
  type: SET_ISREMARKS_LOAD,
  data
});

export const setRedirectToHub = data => ({
  type: SET_ISREDIRECT_TO_HUB,
  data
});

